import { render, staticRenderFns } from "./NsSearchResults.vue?vue&type=template&id=20636109&scoped=true&"
import script from "./NsSearchResults.vue?vue&type=script&lang=js&"
export * from "./NsSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./NsSearchResults.vue?vue&type=style&index=0&id=20636109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20636109",
  null
  
)

export default component.exports